import React, { useEffect, useState, useContext } from "react";
import icon__comment__plus from "./../../asset/icon/comment-plus-small.svg";
import { useNavigate } from "react-router-dom";
import ModalCreate from "../material/modal/ModalCreate";
import Pagination from "../pagination/Pagination";
import ModalUploadMedia from "../material/modal/ModalUploadMedia";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import * as boardApi from "../../service/boardApi";
import NotfoundUi from "../notfound/NotfoundUi";
import moment from "moment/moment";
import { HashLoader } from "react-spinners";
import "moment/locale/th";
import { TrashIcon } from "@heroicons/react/24/outline";
import ModalFAQ from "../material/modal/ModalFAQ";
import styles from "./AnsQandAUserAll.module.css";
import icon__circle__sm from "../../asset/icon/circle-small.svg";

import { CurrentUserContext } from "../../App";

function AnsQandAUserAll({ roleUser }) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [openModalAddMedia, setOpenModalAddMedia] = useState(false);
  const [valueSearch, setValueSearch] = useState("");
  const [valueSearchAuthor, setValueSearchAuthor] = useState("");
  const [valueSearchMedia, setValueSearchMedie] = useState("");
  const [activeBtn, setActiveBtn] = useState("katuu");

  const [loading, setLoading] = useState(false);

  //ตารางกระทู้ทั้งหมด
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const [board_list, setBoard_list] = useState([]);
  const [board_list_storage, setBoard_list_storage] = useState([]);

  //ตารางกระทู้ของฉัน
  const [pagev2, setPagev2] = useState(1);
  const [maxPagev2, setMaxPagev2] = useState(1);

  const [board_list_iam, setBoard_list_iam] = useState([]);
  const [board_list_iam_storage, setBoard_list_iam_storage] = useState([]);

  const [typeNavigate, setTypeNavigate] = useState("");

  useEffect(() => {
    ViewgetBoard();
    ManagegetBoard();
  }, [page, openModalCreate]);

  //ใช้set ตอนกดเข้าไป comment
  useEffect(() => {
    if (roleUser === "Laboratory") {
      setTypeNavigate("/laboratory/comment");
    } else if (roleUser === "Medical") {
      setTypeNavigate("/doctor/comment");
    } else if (roleUser === "Patient") {
      setTypeNavigate("/patient/comment");
    } else if (roleUser === "Admin") {
      setTypeNavigate("/admin/comment");
    } else if (roleUser === "Executive") {
      setTypeNavigate("/manager/comment");
    } else {
      console.log("ไม่พบการเข้าถึงคอมเม้น");
    }
  }, []);

  const ViewgetBoard = async () => {
    setLoading(true);
    let res = await boardApi.ViewgetBoard(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setBoard_list(res["data"]["board_list"]);
        setBoard_list_storage(res["data"]["board_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const ManagegetBoard = async () => {
    setLoading(true);
    let res = await boardApi.ManagegetBoard(page, 100);
    setLoading(false);
    // console.log(res)
    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        let board_list_sort_date = res["data"]["board_list"];
        board_list_sort_date.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return (
            new Date(b.create_date["timestamp"]) -
            new Date(a.create_date["timestamp"])
          );
        });
        setBoard_list_iam(board_list_sort_date);
        setBoard_list_iam_storage(board_list_sort_date);
        setMaxPagev2(
          Math.ceil(
            (res["data"]["amount"] !== Number ? 1 : res["data"]["amount"]) /
              100,
          ),
        );
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const ManageremoveBoard = async (i) => {
    if (
      !window.confirm(`คุณต้องการลบกระทู้ "${i["board_title"]}" ใช่หรือไม่`)
    ) {
      return;
    }
    setLoading(true);
    let res = await boardApi.ManageremoveBoard(i["board_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        ViewgetBoard();
        ManagegetBoard();
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setBoard_list_iam([]);
      setBoard_list_iam_storage([]);
    }
  };

  const handleChangeSearch = (e) => {
    const searchInput = e.target.value;
    setValueSearch(e.target.value);
    if (searchInput !== "") {
      const filteredData = board_list.filter((item) => {
        return item.board_title
          ?.toLowerCase()
          .includes(searchInput?.toLowerCase());
      });
      setBoard_list(filteredData);
    } else {
      setBoard_list(board_list_storage);
    }
  };

  const handleChangeSearchInputAuthor = (e) => {
    const searchInput = e.target.value;
    setValueSearchAuthor(e.target.value);
    if (searchInput !== "") {
      const filteredData = board_list_iam.filter((item) => {
        return item.board_title
          ?.toLowerCase()
          .includes(searchInput?.toLowerCase());
      });
      setBoard_list_iam(filteredData);
    } else {
      setBoard_list_iam(board_list_iam_storage);
    }
  };

  // const handleChangeSearchMedia = (e) => {
  //     console.log(e.target.value)
  // }

  const onClickToComponentAnsPatient = (item) => {
    navigate(typeNavigate, { state: { item } });
  };

  const postApiUploadMedia = async (value, file) => {
    setIsMessage({ type: "warning", data: "กำลังอัปโหลด" });
    setIsMessage({ type: "success", data: "อัปโหลดเสร็จสิ้น" });
    // console.log(value, file)
  };

  const [openModalFAQ, setOpenModalFAQ] = useState(false);

  const [titleFAQ, setTitleFAQ] = useState("");
  const [heightModal, setHeightModal] = useState("");
  const [weightModal, setWeightModal] = useState("");

  const presetTailwind = {
    btnFAQ:
      "transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:transform-none rounded-lg ring-1 ring-[#A2B5BC] h-auto py-3 flex items-center px-5 gap-8 md:gap-4 hover:bg-[#FFF8ED] text-[#000000]",
  };

  return (
    <div>
      {openModalCreate ? (
        <>
          <ModalCreate
            titlename={"เพิ่มกระทู้"}
            onClose={() => {
              setOpenModalCreate(false);
            }}
            placeholder={"ระบุหัวข้อ"}
            placeholderTextArea={"รายละเอียดเพิ่มเติม"}
            btnsubmitname={"ส่งกระทู้"}
            showBtnCancle
            // showIconClose
            limitSizeHeight="h-[400px]"
            limitSizeWeight="w-[500px]"
            type={"addKratuFromDocter"}
          />
        </>
      ) : null}
      {openModalAddMedia ? (
        <>
          <ModalUploadMedia
            titlename={"เพิ่มสื่อ"}
            labelname={"คำอธิบายเนื้อหาวิดีโอ"}
            showIconClose
            onClose={() => {
              setOpenModalAddMedia(false);
            }}
            // placeholder={'คำอธิบายเนื้อหาวิดีโอ'}
            limitSizeHeight="h-[500px]"
            limitSizeWeight="w-[600px]"
            btnsubmitname={"บันทึก"}
            callbackApi={postApiUploadMedia}
          />
        </>
      ) : null}

      {openModalFAQ ? (
        <ModalFAQ
          limitSizeHeight={heightModal}
          limitSizeWeight={weightModal}
          tital={titleFAQ}
          title={titleFAQ}
          onClose={() => {
            setOpenModalFAQ(false);
          }}
        />
      ) : null}
      <div className="flex justify-center">
        <div className="grid gap-8 pt-20 md:pt-12 w-full">
          <p className={styles.title}>คำถามที่พบบ่อย (FAQ)</p>
          <div className="grid gap-5">
            <button
              onClick={() => {
                setOpenModalFAQ(true);
                setTitleFAQ("การตรวจเภสัชพันธุศาสตร์ คืออะไร");
                setHeightModal("md:h-[310px] h-[410px]");
                setWeightModal("md:w-[300px] w-[1000px]");
              }}
              className={`${presetTailwind.btnFAQ}`}
            >
              <img className="md:h-2 h-4" src={icon__circle__sm} alt="" />
              <p className={styles.font}>การตรวจเภสัชพันธุศาสตร์ คืออะไร</p>
            </button>

            <button
              onClick={() => {
                setOpenModalFAQ(true);
                setTitleFAQ("เมื่อไรที่ควรได้รับการตรวจเภสัชพันธุศาสตร์");
                setHeightModal("md:h-[560px] h-[600px]");
                setWeightModal("md:w-[300px] w-[1000px]");
              }}
              className={`${presetTailwind.btnFAQ}`}
            >
              <img className="md:h-2 h-4" src={icon__circle__sm} alt="" />
              <p className={styles.font}>
                เมื่อไรที่ควรได้รับการตรวจเภสัชพันธุศาสตร์
              </p>
            </button>
            <button
              onClick={() => {
                setOpenModalFAQ(true);
                setTitleFAQ(
                  "ผู้ป่วยต้องเตรียมตัวอย่างไรก่อนการเก็บตัวอย่างหรือไม่",
                );
                setHeightModal("md:h-[280px] h-[320px]");
                setWeightModal("md:w-[300px] w-[1000px]");
              }}
              className={`${presetTailwind.btnFAQ}`}
            >
              <img className="md:h-2 h-4" src={icon__circle__sm} alt="" />
              <p className={styles.font}>
                ผู้ป่วยต้องเตรียมตัวอย่างไรก่อนการเก็บตัวอย่างหรือไม่
              </p>
            </button>

            <button
              onClick={() => {
                setOpenModalFAQ(true);
                setTitleFAQ("เมื่อผลการตรวจเป็นบวก หมายความว่าอย่างไร");
                setHeightModal("h-[600px]");
                setWeightModal("md:w-[300px] w-[1000px]");
              }}
              className={`${presetTailwind.btnFAQ}`}
            >
              <img className="md:h-2 h-4" src={icon__circle__sm} alt="" />
              <p className={styles.font}>
                เมื่อผลการตรวจเป็นบวก หมายความว่าอย่างไร
              </p>
            </button>

            <button
              onClick={() => {
                setOpenModalFAQ(true);
                setTitleFAQ("เมื่อผลการตรวจยีนแพ้ยาเป็นลบ หมายความว่าอย่างไร");
                setHeightModal("md:h-[420px] h-[320px]");
                setWeightModal("md:w-[300px] w-[1000px]");
              }}
              className={`${presetTailwind.btnFAQ}`}
            >
              <img className="md:h-2 h-4" src={icon__circle__sm} alt="" />
              <p className={styles.font}>
                เมื่อผลการตรวจยีนแพ้ยาเป็นลบ หมายความว่าอย่างไร
              </p>
            </button>
          </div>
        </div>
      </div>

      {/* <div className='mx-24 md:mx-5'>
                <div className='flex my-10 gap-5'>
                    <button onClick={() => {
                        setActiveBtn('katuu')

                    }} className={`text-[#000000] border-2 border-[#B5DFC8] rounded-3xl h-[45px] w-[180px] ${activeBtn === 'katuu' ? 'bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5]' : 'bi'}`}>
                        กระทู้ทั้งหมด
                    </button>
                    <button onClick={() => {
                        setActiveBtn('katuuOwner')

                    }} className={`text-[#000000] border-2 border-[#B5DFC8] rounded-3xl h-[45px] w-[180px] ${activeBtn === 'katuuOwner' ? 'bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5]' : ''}`}>
                        กระทู้ของฉัน
                    </button>
                </div>
                {activeBtn === 'katuu' ?
                    <>
                        <div className='flex gap-7 w-auto mb-7'>
                            <div className='w-[400px] md:w-[200px]'>
                                <input className='h-12 w-full border-2 border-solid border-[#A2B5BC] rounded-2xl text-state-100 text-[#000000] text-center'
                                    placeholder='ค้นหากระทู้คำถาม'
                                    value={valueSearch}
                                    onChange={handleChangeSearch}
                                ></input>
                            </div>
                            <button className='button-theme-pg flex justify-center items-center bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan '
                                onClick={() => { setOpenModalCreate(true) }}
                            >
                                <div className='text-sm text-[#000000]'>เพิ่มกระทู้</div>
                            </button>
                        </div>
                        <div className='flex justify-center border border-#B5DFC8 rounded-xl px-5 pb-1 pt-4 bg-white drop-shadow-xl'>
                            <div className='overflow-x-scroll '>
                                <div className='2xl:w-[1400px] xl:w-[1100px] lg:w-[1100px] md:w-[1100px] sm:w-[1100px] w-[1100px]'>
                                    <div className='grid grid-cols-[auto_240px_230px_230px] border-b border-[#B8DFC7] gap-3'>
                                        <div className='py-3 text-center'>ชื่อกระทู้</div>
                                        <div className='py-3 ml-5'>โดย</div>
                                        <div className='py-3 text-center'>ความคิดเห็น</div>
                                        <div className='py-3 text-center'>เวลาที่ตั้งกระทู้</div>
                                    </div>
                                    {board_list.length > 0 ?
                                        <>
                                            {board_list.map((i, idx) => {
                                                return (

                                                    <div key={idx} className='grid grid-cols-[auto_240px_230px_230px] border-b border-[#B8DFC7] gap-3'>
                                                        <div className='py-4 hover:cursor-pointer' onClick={() => { onClickToComponentAnsPatient(i) }}>{i['board_title'].length > 50 ? i['board_title'].substring(0, 60) + ' ' + '...' : i['board_title']}</div>
                                                        <div className='py-4 text-[#000000]'>{i['author']['fname'] + ' ' + i['author']['lname']}</div>
                                                        <div className='py-4 text-center relative' onClick={() => { onClickToComponentAnsPatient(i) }}>
                                                            <img className='w-6 absolute top-[14px] left-[90px] hover:cursor-pointer' src={icon__comment__plus} alt='' />
                                                            <div className='text-[#526F65] absolute top-[13px] right-[100px]  hover:cursor-pointer'>{i['number_comments']}</div>
                                                        </div>
                                                        <div className='py-4 text-center text-[#000000]'>{i['create_date']['time'] + ' ' + moment(i['create_date']['timestamp']).add(543, 'years').format('Do MMM YY')}</div>
                                                    </div>
                                                )
                                            })
                                            }
                                        </> : <NotfoundUi title={'ไม่พบกระทู้'} />
                                    }
                                </div>
                            </div>
                        </div>
                        <Pagination
                            page={page}
                            totalpage={maxPage}
                            clickForward={() => {
                                if (page < maxPage) {
                                    setPage(page + 1)
                                }
                            }}
                            clickBackward={() => {
                                if (page > 1) {
                                    setPage(page - 1)
                                }
                            }}
                        />
                    </>
                    : <>
                        {activeBtn === 'katuuOwner' ?
                            <>
                                <div className='flex w-auto gap-7 mb-7'>
                                    <div className='w-[400px] md:w-[200px]'>
                                        <input className='h-12 w-full border-2 border-solid border-[#A2B5BC] rounded-2xl text-state-100 text-[#000000] text-center'
                                            placeholder='ค้นหากะทู้คำถาม'
                                            value={valueSearchAuthor}
                                            onChange={handleChangeSearchInputAuthor}
                                        ></input>
                                    </div>
                                    <button className='button-theme-pg flex justify-center items-center bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan '
                                        onClick={() => { setOpenModalCreate(true) }}
                                    >
                                        <div className='text-sm text-[#000000]'>เพิ่มกระทู้</div>
                                    </button>
                                </div>
                                <div className='flex justify-center border border-#B5DFC8 rounded-xl px-5 pb-1 pt-4 bg-white drop-shadow-xl'>
                                    <div className='overflow-x-scroll '>
                                        <div className='2xl:w-[1400px] xl:w-[1100px] lg:w-[1100px] md:w-[1100px] sm:w-[1100px] w-[1100px]'>
                                            <div className='grid grid-cols-[auto_230px_230px_230px_60px] border-b border-[#B8DFC7] gap-3'>
                                                <div className='py-3 text-center'>ชื่อกระทู้</div>
                                                <div className='py-3 ml-5'>โดย</div>
                                                <div className='py-3 text-center'>ความคิดเห็น</div>
                                                <div className='py-3 text-center'>เวลาที่ตั้งกระทู้</div>
                                                <div className='py-3'>ลบกระทู้</div>
                                            </div>
                                            {board_list_iam.length > 0 ?
                                                <>
                                                    {board_list_iam.map((i, idx) => {

                                                        return (

                                                            <div key={idx} className='grid grid-cols-[auto_230px_230px_230px_60px] border-b border-[#B8DFC7] gap-3'>
                                                                <div className='py-4 hover:cursor-pointer' onClick={() => { onClickToComponentAnsPatient(i) }}>{i['board_title'].length > 50 ? i['board_title'].substring(0, 60) + ' ' + '...' : i['board_title']}</div>
                                                                <div className='py-4 text-[#000000]'>{i['author']['fname'] + ' ' + i['author']['lname']}</div>
                                                                <div className='py-4 text-center relative' onClick={() => { onClickToComponentAnsPatient(i) }}>
                                                                    <img className='w-6 absolute top-[14px] left-[90px] hover:cursor-pointer' src={icon__comment__plus} alt='' />
                                                                    <div className='text-[#526F65] absolute top-[13px] right-[100px]  hover:cursor-pointer'>{i['number_comments']}</div>
                                                                </div>
                                                                <div className='py-4 text-center text-[#000000]'>{i['create_date']['time'] + ' ' + moment(i['create_date']['timestamp']).add(543, 'years').format('Do MMM YY')}</div>
                                                                <div className='flex justify-center'><TrashIcon onClick={() => { ManageremoveBoard(i) }} className='w-6 stroke-[#E4642A] hover:cursor-pointer' />
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </> : <NotfoundUi title={'ไม่พบกระทู้'} />
                                            }
                                        </div>
                                    </div>
                                </div>

                                <Pagination
                                    page={pagev2}
                                    totalpage={maxPagev2}
                                    clickForward={() => {
                                        if (pagev2 < maxPagev2) {
                                            setPagev2(pagev2 + 1)
                                        }
                                    }}
                                    clickBackward={() => {
                                        if (pagev2 > 1) {
                                            setPagev2(pagev2 - 1)
                                        }
                                    }}
                                />
                            </>
                            :
                            <>
                                <div className={`flex justify-center ${roleUser !== 'Medical' ? 'w-[27.42%]' : 'w-2/5'} gap-10 py-10`}>
                                    <input className='h-12 w-3/5 border-2 border-solid border-[#A2B5BC] rounded-2xl text-state-100 text-[#A2B5BC] text-center'
                                        placeholder='ค้นหาสื่อความรู้'
                                        value={valueSearchMedia}
                                        onChange={handleChangeSearchMedia}
                                    ></input>
                                    {roleUser !== 'Medical' ? null :
                                        <>
                                            <button className='button-theme-pg flex justify-center items-center w-32 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan '
                                                onClick={() => { setOpenModalAddMedia(true) }}
                                            >
                                                <div className='text-sm text-[#526F65]'>เพิ่มสื่อ</div>
                                            </button>
                                        </>
                                    }
                                </div>

                                <div className='p-[25px] rounded-xl border border-[#A2B5BC] h-full'>

                                    <div className='grid items-center grid-cols-[50px_auto]'>
                                        <div>img</div>
                                        <div>
                                            <div className='font-bold text-[#339A80]'>fullname</div>
                                            <div className='text-[#2E2E2E]'> เมื่อ 08:30 31/10/22</div>
                                        </div>
                                    </div>

                                    <div className=' bg-[#A2B5BC] my-[15px] rounded-2xl h-[500px] w-full'>

                                    </div>

                                    <div className='text-[#2E2E2E] text-[20px] font-bold my-[10px]'>
                                        title
                                    </div>
                                    <div className='text-[#339A80] indent-[20px] font-medium'>
                                        description
                                    </div>

                                    <div className='my-[10px] flex justify-center items-center gap-[10px]'>
                                        <ChevronLeftIcon className='button-theme-pg p-0 stroke-[#A2B5BC] w-[44px] h-[44px] border-2 border-solid border-[#A2B5BC] rounded-full hover:cursor-pointer' />
                                        <ChevronRightIcon className='button-theme-pg p-0 stroke-[#A2B5BC] w-[44px] h-[44px] border-2 border-solid border-[#A2B5BC] rounded-full hover:cursor-pointer' />
                                    </div>
                                </div>
                            </>
                        }
                    </>

                }
            </div> */}
    </div>
  );
}

export default AnsQandAUserAll;
